<template lang="pug">
main.page.home
	include ../includes/header-basic.pug
	
	section.home-welcome
		.container-fluid
			.row.featured-cards.pt-5.d-none
				.col-md-6.col-12
					.card.cards-featured
						.image-background
							.image(style="background-image: url('images/image-home-01.jpeg');")
						.card-content
							h5 Para Alumnos
							p Lorem Ipsum
							router-link.btn.btn-primary(to="/student") 3,2,1 Comienza!

				.col-md-6.col-12
					.card.cards-featured
						.image-background
							.image(style="background-image: url('images/image-home-02.jpeg');")
						.card-content
							h5 Para Negocios
							p Lorem Ipsum
							router-link.btn.btn-primary(to="/business") 3,2,1 Comienza!
			.row.no-gutters
				.col-sm-6.col-12.p-3
					article.b2c.card.no-shadow.border-round-sm
						.image-background
							.image(style="opacity: 1;background-image: url('images/image-home-01-960.jpg');")
						.card-content.d-flex.mt-auto.align-items-end
							.col-sm-10.col-lg-10.col-12
								h4.mb-3.text-white Para alumnos
								h5.mb-3.text-white Reserva tus clase y registra tu progreso
								router-link.btn.btn-primary.mb-4(to="/student") Entrena!

				.col-sm-6.col-12.p-3
					article.b2b.card.no-shadow.border-round-sm
						.image-background
							.image(style="opacity: 1;background-image: url('images/image-home-02-960.jpg")
						.card-content.d-flex.mt-auto.align-items-end
							.col-sm-10.col-lg-10.col-12
								h4.mb-3.text-white Para Negocios
								h5.mb-3.text-white Administra tu agenda de clases, controla los pagos y mucho más...
								router-link.btn.btn-primary.mb-4( to="/business") Administra!
	include ../includes/footer.pug
	
</template>

<script>
	export default {
		name: 'home'
	}
</script>
